/**
 * Generate public URL for an asset
 * Converts internal API URL to public CDN URL
 * 
 * @param assetId - Asset ID (e.g., 'ast_40891067-4ad5-4f3f-9c22-fa92601919bb')
 * @param contentType - Content type (e.g., 'image/png')
 * @returns Public URL (e.g., 'https://www.content-growth.cn/images/40891067-4ad5-4f3f-9c22-fa92601919bb')
 */
export function getPublicAssetUrl(assetId: string, contentType: string = 'image'): string {
  if (!assetId || !assetId.startsWith('ast_')) {
    throw new Error('Invalid asset ID');
  }

  // Get current origin and replace subdomain with 'www'
  const wwwUrl = new URL(window.location.origin);
  wwwUrl.hostname = wwwUrl.hostname.replace(/^(app|[^.]+)\./, 'www.');

  // Extract UUID from asset ID (remove 'ast_' prefix)
  const uuid = assetId.substring(4);

  // Determine path segment based on content type
  const isImage = contentType.startsWith('image');
  const pathSegment = isImage ? 'images' : 'files';

  return `${wwwUrl.origin}/${pathSegment}/${uuid}`;
}
